import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-informations-commande-messages',
  templateUrl: './informations-commande-messages.component.html',
  styleUrls: ['./informations-commande-messages.component.scss'],
})
export class InformationsCommandeMessagesComponent {
  @Input() isRenouvellementMessageVisible: boolean = false;
}
